<template>
  <div>
    <div
      v-if="successMessage"
      class="alert alert-success"
      style="color: rgb(5, 20, 48)"
    >
      {{ successMessage }}
    </div>
    <b-card>
      <b-row>
        <div class="col-12 mt-16">
          <b-form @submit.prevent="addUser" v-if="show">
            <div
              style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;"
            >
              <h4
                style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;"
              >
                Slider Information
              </h4>
            </div>

            <div class="row">
              <div class="col-md-6 col-12">
                <b-form-group label="URL:" label-for="url">
                  <b-form-textarea
                    class="form-control"
                    id="url"
                    placeholder="Enter URL"
                    v-model="url"
                    :state="validateField(url)"
                    required
                  ></b-form-textarea>
                </b-form-group>
              </div>

              <div class="col-md-6 col-12">
                <b-form-group label="Picture:" label-for="image">
                <!-- Preview (if selected) -->
                <div v-if="previewImage" class="mb-3 text-center">
                    <img
                    :src="previewImage"
                    alt="Picture Preview"
                    class="img-thumbnail"
                    style="max-width: 150px; max-height: 150px; object-fit: cover;"
                    />
                    <div>
                    <b-button
                        size="sm"
                        variant="danger"
                        class="mt-2"
                        @click="removeImage"
                    >
                        Remove
                    </b-button>
                    </div>
                </div>

                <!-- Drag & Drop Zone (always visible, even if preview exists) -->
                <div
                    class="border rounded p-3 text-center"
                    style="cursor: pointer; background: #f9f9f9; min-height: 120px;"
                    @drop.prevent="handleDrop"
                    @dragover.prevent
                    @click="$refs.imageInput.click()"
                >
                    <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                    <p class="mb-0">Drag & Drop or Click to Upload</p>
                </div>

                <!-- File Input (restrict to 1 file) -->
                <input
                    ref="imageInput"
                    type="file"
                    accept="image/*"
                    class="d-none"
                    @change="onImageChange"
                />

                <small class="text-muted">Only JPG/PNG, Max size: 2MB</small>
                <b-form-invalid-feedback v-if="imageError" class="d-block text-danger">
                    {{ imageError }}
                </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>

            <b-button
              type="submit"
              variant="primary"
              class="mb-8 mr-8"
              :disabled="isLoading"
            >
              <span v-if="!isLoading">Submit</span>
              <b-spinner
                v-else
                class="mb-8 mr-8"
                variant="primary"
                small
              ></b-spinner>
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
  BToast,
  BFormInvalidFeedback,
  BFormTextarea,
} from "bootstrap-vue";
import axios from "../../../axios";

export default {
  data() {
    return {
      show: true,
      isLoading: false,
      successMessage: "",

      url: "",
      imageFile: null, // actual file for upload
      previewImage: "", // preview URL
      imageError: "",

      editedUser: {},
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BToast,
    BSpinner,
    BFormInvalidFeedback,
    BFormTextarea,
  },
  created() {
    const userId = this.$route.params.id;
    axios
      .get(`sliderShow/${userId}`)
      .then((response) => {
        this.editedUser = response.data.data;
        this.url = this.editedUser.url;
        if (this.editedUser.image) {
          this.previewImage =
            "https://wossdb.wossautoid.com/" + this.editedUser.image;
        }
      })
      .catch((error) => {
        console.error("Error fetching slider data:", error);
      });
  },
  methods: {
    validateField(value) {
      if (value === null || value === undefined || value === "") return null;
      return value.toString().trim().length > 0;
    },
    onImageChange(e) {
      const file = e.target.files[0];
      this.handleFile(file);
    },
    handleDrop(e) {
      const file = e.dataTransfer.files[0];
      this.handleFile(file);
    },
    handleFile(file) {
      if (!file) return;

      if (!file.type.startsWith("image/")) {
        this.imageError = "Only image files allowed.";
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.imageError = "Max file size is 5MB.";
        return;
      }

      this.imageFile = file;
      this.previewImage = URL.createObjectURL(file);
      this.imageError = "";
    },
    removeImage() {
      this.imageFile = null;
      this.previewImage = "";
    },
    addUser() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append("url", this.url);

      if (this.imageFile) {
        formData.append("image", this.imageFile);
      }

      axios
        .post(`sliderUpdate/${this.editedUser.id}`, formData)
        .then(() => {
          this.$bvToast.toast("Slider updated successfully!", {
            title: "Success",
            variant: "primary",
            solid: true,
          });
          this.isLoading = false;
          this.$router.push({ name: "ListSlider" });
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Update error:", error);
        });
    },
  },
};
</script>
